import React, {Component} from 'react'
import {connect} from 'react-redux'
import {actions} from 'react-redux-form'
import {Grid, Row, Col} from 'react-bootstrap'
import EditArticleForm from './article-edit-form';
import BackLink from '../../../../common/back-link/index'
import PageTitle from "../../../../common/page-title/index";
import {getArticle, getArticles} from '../../../../../actions/news'

// import './styles.css'

class EditArticle extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const id = +this.props.match.params.id;
    this.props.dispatch(getArticle(id));
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.admin_news.article'));
    this.props.dispatch({type: 'CLEAR_EDIT_NEWS_ARTICLE'});
  }

  render() {
    return (
      <Grid bsClass="container" className="articles">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/news/articles"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>Add/Edit article</PageTitle>
            <EditArticleForm article={this.props.article}
                             linkArticles={this.props.articleList}
                             statusList={this.props.statusList}
                             categoryList={this.props.categoryList}
                             permissions={this.props.permissions}/>
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    article:      state.news.articles.article,
    fetched:      state.news.articles.fetched,
    fetching:     state.news.articles.fetching,
    articleList:  state.news.articles.editorInput.articles,
    statusList:   state.news.articles.editorInput.statuses,
    categoryList: state.news.articles.editorInput.categories,
    permissions:  state.news.articles.editorInput.permissions,
  };
};

export default connect(mapStateToProps)(EditArticle);



// WEBPACK FOOTER //
// ./src/components/admin/news/articles/edit/index.jsx